import React, { useEffect } from "react";
import GreenAudioPlayer from "green-audio-player";
import PlayerStyles from "../styles/PlayerStyles";

export default function AudioPlayer({ url }) {
  useEffect(() => {
    new GreenAudioPlayer(".player");
  });
  return (
    <PlayerStyles>
      <div className="player">
        <audio>
          <source src={url} type="audio/mpeg" />
        </audio>
      </div>
    </PlayerStyles>
  );
}
